import { ActivateResponse } from '../models/activateResponse'

export function activateUser(activateRepository, contextData, usersData, processId) {
  return activateRepository.activateUser(contextData, usersData, processId).then(data => new ActivateResponse(data));
}